import { useState } from 'react'
import { motion } from 'framer-motion'
import SafeIcon from '../common/SafeIcon'
import Modal from './common/Modal'
import * as FiIcons from 'react-icons/fi'
import * as MdIcons from 'react-icons/md'
import * as BsIcons from 'react-icons/bs'
import * as FaIcons from 'react-icons/fa'

function BusinessSolutionsSection() {
  const [selectedBusiness, setSelectedBusiness] = useState(null)

  const businessSolutions = [
    {
      id: 1,
      title: 'Για Καφετέριες & Εστιατόρια',
      description: 'Ολοκληρωμένες λύσεις για επιχειρήσεις εστίασης που θέλουν να αναβαθμίσουν την εμπειρία των πελατών τους.',
      icon: MdIcons.MdRestaurant,
      color: 'from-orange-500 to-red-500',
      services: [
        'Ψηφιακά μενού με QR code',
        'POS & Ταμειακές συστήματα με διασύνδεση ΑΑΔΕ',
        'Συστήματα παραγγελιοληψίας',
        'Social media marketing & προβολή',
        'Wi-Fi marketing & customer analytics'
      ],
      image: 'https://images.unsplash.com/photo-1414235077428-338989a2e8c0?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
    },
    {
      id: 2,
      title: 'Για Τουριστικές Μονάδες',
      description: 'Εξειδικευμένες υπηρεσίες για ξενοδοχεία και καταλύματα που θέλουν να αυξήσουν τις κρατήσεις και την ικανοποίηση των πελατών.',
      icon: MdIcons.MdHotel,
      color: 'from-blue-500 to-cyan-500',
      services: [
        '360° virtual tours για τους χώρους σας',
        'Συστήματα online κρατήσεων',
        'Πλατφόρμες αξιολόγησης & review management',
        'Προβολή σε booking platforms & OTAs',
        'Αυτοματισμοί επικοινωνίας με πελάτες'
      ],
      image: 'https://images.unsplash.com/photo-1566073771259-6a8506099945?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
    },
    {
      id: 3,
      title: 'Για Εκπαιδευτικά Ιδρύματα',
      description: 'Καινοτόμες λύσεις για σχολεία, φροντιστήρια και εκπαιδευτικούς οργανισμούς που θέλουν να βελτιώσουν την εκπαιδευτική διαδικασία.',
      icon: FaIcons.FaGraduationCap,
      color: 'from-green-500 to-emerald-500',
      services: [
        'Learning Management Systems (LMS)',
        'Πλατφόρμες online μαθημάτων & webinars',
        'Συστήματα αξιολόγησης & παρακολούθησης προόδου',
        'Ψηφιακή βιβλιοθήκη & διαχείριση περιεχομένου',
        'Εφαρμογές gamification για μαθητές'
      ],
      image: 'https://images.unsplash.com/photo-1523240795612-9a054b0db644?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
    },
    {
      id: 4,
      title: 'Για Επαγγελματίες Υγείας',
      description: 'Εξειδικευμένες λύσεις για ιατρεία, φυσικοθεραπευτές και επαγγελματίες υγείας που θέλουν να προσφέρουν καλύτερες υπηρεσίες.',
      icon: FaIcons.FaUserMd,
      color: 'from-purple-500 to-pink-500',
      services: [
        'Συστήματα online ραντεβού',
        'Patient portals & ιατρικοί φάκελοι',
        'Telemedicine & video consultation',
        'Digital marketing για προσέλκυση ασθενών',
        'SEO & online προβολή υπηρεσιών υγείας'
      ],
      image: 'https://images.unsplash.com/photo-1559757148-5c350d0d3c56?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
    },
    {
      id: 5,
      title: 'Για Λιανικό Εμπόριο',
      description: 'Ολοκληρωμένες λύσεις για καταστήματα λιανικής που θέλουν να αυξήσουν τις πωλήσεις τους και να βελτιώσουν την εμπειρία των πελατών.',
      icon: BsIcons.BsShop,
      color: 'from-indigo-500 to-blue-500',
      services: [
        'E-shop & omnichannel λύσεις',
        'POS & inventory management',
        'Συστήματα loyalty & customer engagement',
        'Digital signage & in-store marketing',
        'Marketing automation & email campaigns'
      ],
      image: 'https://images.unsplash.com/photo-1441986300917-64674bd600d8?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
    },
    {
      id: 6,
      title: 'Για Επιχειρήσεις Υπηρεσιών',
      description: 'Εξειδικευμένες λύσεις για επαγγελματίες και επιχειρήσεις παροχής υπηρεσιών που θέλουν να αναπτυχθούν και να προσελκύσουν νέους πελάτες.',
      icon: FiIcons.FiBriefcase,
      color: 'from-yellow-500 to-orange-500',
      services: [
        'Professional websites & landing pages',
        'Συστήματα CRM & lead management',
        'Αυτοματισμοί marketing & πωλήσεων',
        'SEO & content marketing',
        'Case studies & portfolio websites'
      ],
      image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
    }
  ]

  const scrollToContact = () => {
    const contactSection = document.getElementById('contact')
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' })
    }
  }

  return (
    <section id="business-solutions" className="py-20 bg-gradient-to-br from-gray-50 via-white to-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-4xl md:text-5xl font-bold text-gray-900 mb-6"
          >
            Λύσεις ανά <span className="text-blue-600">Επιχείρηση</span>
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
            className="text-xl text-gray-600 max-w-3xl mx-auto"
          >
            Εξειδικευμένες λύσεις προσαρμοσμένες στις ανάγκες διαφορετικών κλάδων και επιχειρήσεων. 
            Ανακαλύψτε πώς μπορούμε να βοηθήσουμε τη δική σας επιχείρηση να αναπτυχθεί.
          </motion.p>
        </div>

        {/* Business Solutions Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {businessSolutions.map((business, index) => (
            <motion.div
              key={business.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="group relative bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden"
            >
              {/* Background Image */}
              <div className="absolute inset-0 opacity-5 group-hover:opacity-10 transition-opacity duration-300">
                <img 
                  src={business.image} 
                  alt={business.title}
                  className="w-full h-full object-cover"
                />
              </div>

              {/* Gradient Overlay */}
              <div className={`absolute inset-0 bg-gradient-to-br ${business.color} opacity-5 group-hover:opacity-10 transition-opacity duration-300`}></div>

              {/* Content */}
              <div className="relative p-8">
                {/* Icon */}
                <div className={`inline-flex items-center justify-center w-16 h-16 rounded-xl bg-gradient-to-br ${business.color} mb-6`}>
                  <SafeIcon 
                    icon={business.icon} 
                    className="h-8 w-8 text-white" 
                  />
                </div>

                {/* Title */}
                <h3 className="text-xl font-bold text-gray-900 mb-4 group-hover:text-blue-600 transition-colors">
                  {business.title}
                </h3>

                {/* Description */}
                <p className="text-gray-600 mb-6 leading-relaxed">
                  {business.description}
                </p>

                {/* Services Preview */}
                <div className="mb-6">
                  <h4 className="text-sm font-semibold text-gray-900 mb-3">Τι προσφέρουμε:</h4>
                  <ul className="space-y-2">
                    {business.services.slice(0, 3).map((service, idx) => (
                      <li key={idx} className="flex items-start text-sm text-gray-600">
                        <SafeIcon 
                          icon={FiIcons.FiCheck} 
                          className="h-4 w-4 text-green-500 mt-0.5 mr-2 flex-shrink-0" 
                        />
                        {service}
                      </li>
                    ))}
                    {business.services.length > 3 && (
                      <li className="text-sm text-blue-600 font-medium">
                        +{business.services.length - 3} ακόμη υπηρεσίες
                      </li>
                    )}
                  </ul>
                </div>

                {/* Button */}
                <button
                  onClick={() => setSelectedBusiness(business)}
                  className={`w-full bg-gradient-to-r ${business.color} text-white py-3 px-6 rounded-xl font-semibold hover:shadow-lg transform hover:-translate-y-0.5 transition-all duration-300`}
                >
                  Μάθετε περισσότερα
                </button>
              </div>
            </motion.div>
          ))}
        </div>
      </div>

      {/* Modal for Business Details */}
      {selectedBusiness && (
        <Modal
          isOpen={!!selectedBusiness}
          onClose={() => setSelectedBusiness(null)}
          title={selectedBusiness.title}
        >
          <div className="space-y-6">
            {/* Image */}
            <div className="relative h-48 rounded-xl overflow-hidden">
              <img 
                src={selectedBusiness.image} 
                alt={selectedBusiness.title}
                className="w-full h-full object-cover"
              />
              <div className={`absolute inset-0 bg-gradient-to-br ${selectedBusiness.color} opacity-20`}></div>
            </div>

            {/* Description */}
            <p className="text-gray-600 leading-relaxed">
              {selectedBusiness.description}
            </p>

            {/* Services */}
            <div>
              <h4 className="text-lg font-semibold text-gray-900 mb-4">Τι προσφέρουμε:</h4>
              <div className="grid grid-cols-1 gap-3">
                {selectedBusiness.services.map((service, idx) => (
                  <div key={idx} className="flex items-start p-3 bg-gray-50 rounded-lg">
                    <SafeIcon 
                      icon={FiIcons.FiCheck} 
                      className="h-5 w-5 text-green-500 mt-0.5 mr-3 flex-shrink-0" 
                    />
                    <span className="text-gray-700">{service}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* CTA Button */}
            <div className="pt-4 border-t">
              <button
                onClick={scrollToContact}
                className={`w-full bg-gradient-to-r ${selectedBusiness.color} text-white py-3 px-6 rounded-xl font-semibold hover:shadow-lg transform hover:-translate-y-0.5 transition-all duration-300`}
              >
                Επικοινωνήστε για Προσφορά
              </button>
            </div>
          </div>
        </Modal>
      )}
    </section>
  )
}

export default BusinessSolutionsSection